// ----------------------------------------------------------------------------- //
//  Site search
// ----------------------------------------------------------------------------- //
document.addEventListener( "readystatechange", function(event) {
	if ( event.target.readyState === 'complete' ) {	

		const searchToggle = document.querySelectorAll('button[aria-controls="site_search_container"]');

		if ( searchToggle.length ) {
			searchToggle.forEach((btn) => {
				btn.addEventListener("click", () => {
					if ( btn.getAttribute("aria-expanded") == "false") {
						document.getElementById("site_search_toggle").focus();
					} else {
						document.getElementById("site_search_input").focus();
					}
				});
			});
		}
	}
});
